export default class LegDashTabs {
  constructor(tabs) {
    this.tabs = tabs;
    this.tabButtons = tabs.querySelectorAll('[role="tab"]');
    this.dashContainer = tabs.parentElement;
    this.tabPanelsArray = Array.from(
      this.dashContainer.querySelectorAll('[role="tabpanel"]')
    );
    this.hash = location.hash;

    this.events();
  }

  events() {
    this.tabButtons.forEach((button) =>
      button.addEventListener('click', () =>
        this.handleTabClick(button, this.tabButtons, this.tabPanelsArray)
      )
    );

    this.handleHash();
  }

  handleHash() {
    if (this.hash) {
      const tabToClick = document.querySelector(this.hash);
      if (tabToClick) {
        tabToClick.click();
      }
    } else {
      this.handleHeightContainer(this.tabPanelsArray[0]);
    }
  }

  handleTabClick(button, tabButtons, tabPanels) {
    const { id } = button;

    // Find associate tab panel
    const tabPanel = tabPanels.find(
      (panel) => panel.getAttribute('aria-labelledby') === id
    );

    if (tabPanel) {
      // hide all tab panels
      this.hideAllPanels(tabPanels);

      // mark all tab buttons as unselected
      this.unSelectsAllTabButtons(tabButtons);

      // mark the clicked tab as selected
      button.setAttribute('aria-selected', true);

      // show the panel
      tabPanel.classList.add('--show-panel');

      // scroll sections to top
      this.scrollSectionsToTop(tabPanel);

      // run after panel is visible and displayed
      this.handleHeightContainer(tabPanel);

      window.location.hash = id;
    }
    //end if tabPanel

    //put in time out to make async
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 0);
  }

  scrollSectionsToTop(panel) {
    const scrollableSections = panel.querySelectorAll('.--contain-height');

    if (scrollableSections.length > 0) {
      scrollableSections.forEach((section) => {
        //console.log(section);
        section.scrollTop = 0;
      });
    }
  }

  handleHeightContainer(panel) {
    let tabPanelSidebar = '';
    let tabPanelSidebarHeight = 0;
    let tabPanelSidebarTop = 0;
    let heightContainer = '';
    let childHightContainer = '';

    tabPanelSidebar = panel.querySelector('.js-leg-panel-sidebar');

    if (tabPanelSidebar && window.innerWidth >= 840) {
      heightContainer = panel.querySelector('.js-leg-main-panel');

      if (heightContainer.classList.contains('use-child-height-container')) {
        childHightContainer = panel.querySelector('.child-height-container');
      }

      tabPanelSidebarHeight = tabPanelSidebar.getBoundingClientRect().height;
      tabPanelSidebarTop = tabPanelSidebar.getBoundingClientRect().top;

      if (window.innerHeight - tabPanelSidebarTop < tabPanelSidebarHeight) {
        if (childHightContainer) {
          childHightContainer.classList.remove('--contain-height');
        } else {
          heightContainer.classList.remove('--contain-height');
        }
      } else {
        if (childHightContainer) {
          childHightContainer.classList.add('--contain-height');
        } else {
          heightContainer.classList.add('--contain-height');
        }
      }
    }
  }

  hideAllPanels(panels) {
    panels.forEach((panel) => {
      panel.classList.remove('--show-panel');
    });
  }

  unSelectsAllTabButtons(buttons) {
    buttons.forEach((tab) => {
      tab.setAttribute('aria-selected', false);
    });
  }
}
